import { LicenseInfo } from '@mui/x-data-grid-pro'

LicenseInfo.setLicenseKey(
  '5fafca040ae1f1b26ed673f9276d9b6cTz0xMTEyNTMsRT0xNzc1OTUxOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
)
